import { Icon, IconName } from "~/components/icon/icon";
import { Input } from "~/components/ui/input";
import { cn } from "~/utils";
import { KebabCase } from "~/utils/types";

interface IconInputProps extends React.ComponentProps<"input"> {
  iconName: KebabCase<IconName>;
  value: string;
  inputClassName?: string;
}

export const IconInput = ({
  iconName,
  className,
  inputClassName,
  ...rest
}: IconInputProps) => (
  <div
    className={cn(
      "flex border border-secondary-300 rounded-lg overflow-hidden focus-within:outline-solid focus-within:outline-1 focus-within:outline-primary focus-within:ring-3 focus-within:ring-offset-0 focus-within:ring-primary-100",
      className,
    )}
  >
    <span className="px-3 text-secondary-500 border-0 border-r flex items-center">
      <Icon name={iconName} />
    </span>

    <Input
      className={cn(
        "flex-1 rounded-none border-0 focus:outline-hidden focus:border-0 shadow-none! text-body",
        inputClassName,
      )}
      {...rest}
    />
  </div>
);
